module.exports = __webpack_public_path__ + "static/media/icon-facebook.b1e9df7e.svg";